import BreadcrumbView from './BreadcrumbView.vue'
BreadcrumbView.install = function (Vue) {
  Vue.component(BreadcrumbView.name, BreadcrumbView)
}
export { BreadcrumbView }
